import { render, staticRenderFns } from "./notVerified.vue?vue&type=template&id=27d9fb6a&"
import script from "./notVerified.vue?vue&type=script&lang=js&"
export * from "./notVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports